export interface ApiCheckSensitiveWordsRequest {
    content: string;
}


export const CheckSensitiveWords = Symbol('CheckSensitiveWords');

export interface CheckSensitiveWords {
    checkSensitiveWords(data: ApiCheckSensitiveWordsRequest): Promise<string>;
}
